/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactSiegeSocialGridDto
 */
export interface ContactSiegeSocialGridDto {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeSocialGridDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    denominationSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    nomPatron?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeSocialGridDto
     */
    numeroBce?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactSiegeSocialGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the ContactSiegeSocialGridDto interface.
 */
export function instanceOfContactSiegeSocialGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeSocialGridDtoFromJSON(json: any): ContactSiegeSocialGridDto {
    return ContactSiegeSocialGridDtoFromJSONTyped(json, false);
}

export function ContactSiegeSocialGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeSocialGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'denominationSociale': !exists(json, 'denominationSociale') ? undefined : json['denominationSociale'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'nomPatron': !exists(json, 'nomPatron') ? undefined : json['nomPatron'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'numeroBce': !exists(json, 'numeroBce') ? undefined : json['numeroBce'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function ContactSiegeSocialGridDtoToJSON(value?: ContactSiegeSocialGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocial': value.idsiegeSocial,
        'denominationSociale': value.denominationSociale,
        'gsm': value.gsm,
        'telephone': value.telephone,
        'nomPatron': value.nomPatron,
        'email': value.email,
        'localite': value.localite,
        'numeroBce': value.numeroBce,
        'actif': value.actif,
    };
}

